import { ValidationError } from 'yup'

function determineCheckoutErrors(
    hasEmail: boolean,
    errors: ValidationError,
    setCheckoutFormErrors: Function
) {
    // if email is added, filter out yup valid email errors
    if (hasEmail) {
        const nonValidEmailErrors: ValidationError[] =
            errors.inner?.filter(
                (error) => error.message !== 'A valid email address is required'
            ) ?? []
        setCheckoutFormErrors(nonValidEmailErrors)
        return
    }

    // if not, include all
    setCheckoutFormErrors(errors.inner)
}

export default determineCheckoutErrors
